/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  TokenUpdateResponse,
  TokenUpdateRequest
} from './schema'



export const utxUniversalNotificationSystemLogin = (
    tokenUpdateRequest: TokenUpdateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TokenUpdateResponse>> => {
    return axios.post(
      `/universal-notification-system/token-update`,
      tokenUpdateRequest,options
    );
  }



    export type UtxUniversalNotificationSystemLoginMutationResult = NonNullable<Awaited<ReturnType<typeof utxUniversalNotificationSystemLogin>>>
    export type UtxUniversalNotificationSystemLoginMutationBody = TokenUpdateRequest
    export type UtxUniversalNotificationSystemLoginMutationError = AxiosError<unknown>

    export const useUtxUniversalNotificationSystemLogin = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUniversalNotificationSystemLogin>>, TError,{data: TokenUpdateRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUniversalNotificationSystemLogin>>, {data: TokenUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUniversalNotificationSystemLogin(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUniversalNotificationSystemLogin>>, TError, {data: TokenUpdateRequest}, TContext>(mutationFn, mutationOptions)
    }
    